import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 15,
		height: 15,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function ObligatoryIcon(props) {
	return (
		<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="7.5" cy="7.5" r="7.5" fill={props.fill} />
			<path fillRule="evenodd" clipRule="evenodd" d="M7.5 5C7.77614 5 8 5.16789 8 5.375V7.625C8 7.83211 7.77614 8 7.5 8C7.22386 8 7 7.83211 7 7.625V5.375C7 5.16789 7.22386 5 7.5 5Z" fill="white" />
			<circle cx="7.5" cy="9.5" r="0.5" fill="white" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<ObligatoryIcon fill={props.fill} />
		</div>
	);
}